"use client";

import * as React from "react";
import { cn } from "@/lib/utils";
import { SearchX } from "lucide-react";
import { Button } from "./button";
import useTranslation from "next-translate/useTranslation";

export interface NoResultProps {
  title?: string;
  description?: string;
  icon?: React.ReactNode;
  onRetry?: () => void;
  retryLabel?: string;
  className?: never;
}

export function NoResult({
  title,
  description,
  icon,
  onRetry,
  retryLabel,
  className,
}: NoResultProps) {
  const { t } = useTranslation("common");

  return (
    <div
      className={cn(
        "flex flex-col items-center justify-center gap-4 py-12",
        className
      )}
    >
      <div className="flex h-16 w-16 items-center justify-center rounded-full bg-slate-100 dark:bg-zinc-800">
        {icon || (
          <SearchX className="h-7 w-7 text-slate-400 dark:text-zinc-500" />
        )}
      </div>
      <div className="space-y-1 text-center">
        <h3 className="text-base font-semibold text-slate-900 dark:text-white">
          {title || t("No se encontraron resultados")}
        </h3>
        {description && (
          <p className="max-w-sm text-sm text-slate-600 dark:text-zinc-400">
            {description}
          </p>
        )}
      </div>
      {onRetry && (
        <Button variant="outline" size="sm" onClick={onRetry}>
          {retryLabel || t("Intentar de nuevo")}
        </Button>
      )}
    </div>
  );
}
